import { useCallback } from 'react';

import { IContract } from 'modules/customer/domain/entities';
import { PendencyCheckoutProcessDTO } from 'modules/customer/infra/dtos/PendencyCheckoutProcessDTO';
import { useSetContractCheckoutData } from 'modules/customer/presentation/store';
import { TPaymentMethodType } from 'shared/domain/entities';
import { makeHashProvider } from 'shared/infra/providers';
import { useNavigation } from 'shared/presentation/contexts';

type TParams = {
  contract: IContract;
  methods: TPaymentMethodType[];
};

export default function usePayAllDebtsButtonHandler({
  contract,
  methods,
}: TParams) {
  const navigation = useNavigation();
  const setCheckoutData = useSetContractCheckoutData();

  return useCallback(() => {
    let totalOverdueValue = 0;
    const overdueIds: number[] = [];
    contract.installments.forEach(installment => {
      if (installment.status !== 'OVERDUE') return;

      overdueIds.push(installment.id);
      totalOverdueValue += installment.value.withInterest;
    });

    if (!overdueIds.length || !totalOverdueValue) return;

    setCheckoutData({
      customer: contract.customer,
      value: totalOverdueValue,
      unit: contract.unit,
      methods,
      contractId: contract.id,
      process: new PendencyCheckoutProcessDTO(
        {
          accounts: overdueIds,
          unitId: contract.unit.id,
          customerId: contract.customer.id,
        },
        makeHashProvider(),
      ),
    });
    navigation.push('/cliente/contratos/pagamento');
  }, [
    contract.id,
    contract.customer,
    contract.unit,
    contract.installments,
    methods,
    navigation,
    setCheckoutData,
  ]);
}
